export default {
  name: 'Germany',
  phonePattern: '01701234567',
  postalCodePattern: '11111',
  singlePostalCode: '',
  postalCodeRegex: '^[\\d]{5}$',
  language: 'de-DE',
  dobFormat: 'DD.MM.YY',
  provinces: [{
    name: 'Baden-Württemberg',
    ISOCode: 'DE-BW'
  }, {
    name: 'Bayern',
    ISOCode: 'DE-BY'
  }, {
    name: 'Berlin',
    ISOCode: 'DE-BE'
  }, {
    name: 'Brandenburg',
    ISOCode: 'DE-BB'
  }, {
    name: 'Bremen',
    ISOCode: 'DE-HB'
  }, {
    name: 'Hamburg',
    ISOCode: 'DE-HH'
  }, {
    name: 'Hessen',
    ISOCode: 'DE-HE'
  }, {
    name: 'Mecklenburg-Vorpommern',
    ISOCode: 'DE-MV'
  }, {
    name: 'Niedersachsen',
    ISOCode: 'DE-NI'
  }, {
    name: 'Nordrhein-Westfalen',
    ISOCode: 'DE-NW'
  }, {
    name: 'Rheinland-Pfalz',
    ISOCode: 'DE-RP'
  }, {
    name: 'Saarland',
    ISOCode: 'DE-SL'
  }, {
    name: 'Sachsen',
    ISOCode: 'DE-SN'
  }, {
    name: 'Sachsen-Anhalt',
    ISOCode: 'DE-ST'
  }, {
    name: 'Schleswig-Holstein',
    ISOCode: 'DE-SH'
  }, {
    name: 'Thüringen',
    ISOCode: 'DE-TH'
  }]
}



// WEBPACK FOOTER //
// ./src/locales/countries/DE.js